// extracted by mini-css-extract-plugin
module.exports = {"info":"_1Morw","time":"_3ySE-","title":"YWWOx","ellipsis":"_1E1HB","more":"_24nTe"};